// Angular
import { Injectable } from '@angular/core';

// Libraries
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, takeUntil } from 'rxjs';

// Models
import { AppCleanup } from '../models';

// Store
import { StorageState } from '../state/storage.state';
import { StorageActions } from '../state/storage.action';

export interface Locale {
	lang: string;
	// tslint:disable-next-line:ban-types
	data: Object;
}

@Injectable({
	providedIn: 'root',
})
export class TranslationService extends AppCleanup {
	// Private properties
	private langIds: any = [];

	/**
	 * Service Constructor
	 *
	 * @param translate: TranslateService
	 */
	@Select(StorageState.language) language$: Observable<string>;
	constructor(
		private translateService: TranslateService,
		private store: Store
	) {
		super();

		// add new langIds to the list
		this.translateService.addLangs(['en']);

		// this language will be used as a fallback when a translation isn't found in the current language
		this.translateService.setDefaultLang('en');
	}

	/**
	 * Load Translation
	 *
	 * @param args: Locale[]
	 */
	loadTranslations(...args: Locale[]) {
		const locales = [...args];

		locales.forEach((locale) => {
			// use setTranslation() with the third argument set to true
			// to append translations instead of replacing them
			this.translateService.setTranslation(locale.lang, locale.data, true);

			this.langIds.push(locale.lang);
		});

		// add new languages to the list
		this.translateService.addLangs(this.langIds);
	}

	setLanguage(lang) {
		if (lang) {
			this.translateService.use(this.translateService.getDefaultLang());
			this.translateService.use(lang);
			this.store.dispatch(new StorageActions.SetLanguage(lang));
		}
	}

	getSelectedLanguage() {
		return new Observable((obs) => {
			this.language$.pipe(takeUntil(this.destroy)).subscribe((language) => {
				obs.next(language || this.translateService.getDefaultLang());
			});
		});
	}
}
